import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { Accordion, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import Moment from "react-moment";
import ScrollContainer from "react-indiana-drag-scroll";
import { IoIosArrowDropdownCircle, IoMdPlay } from "react-icons/io";
import { MdKeyboardArrowRight, MdKeyboardArrowDown } from "react-icons/md";

import { fetchOwnerHorsesHistory } from "../../redux/getReducer/getOwnerHorsesHistory";
import { fetchownerhorsekindStats } from "../../redux/getReducer/getOwnerHorseKind";
import PleaseWait from "../Reuseable/PleaseWait";
import NoHistory from "../Reuseable/NoHistory";
import Pagination from "../../pages/Pagination";
import VideoFrame from "../Modal/VideoFrame";
import JockeyDetail from "../Modal/JockeyModal";
import HorseModal from "../Modal/HorseModal";
import RaceModal from "../Modal/RaceModal";
import { truncateRaceType, toTitleCase } from "../../service/stringUtils"; 

const Stats = ({ id }) => {
  const { data: ownerhorsekindstats } = useSelector((state) => state.ownerhorsekindstats);
  const { data: OwnerHorsesHistory } = useSelector((state) => state.OwnerHorsesHistory);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const cookiedata = Cookies.get("i18next");

  // PAGINATION
  let totalcountdata = ownerhorsekindstats ? ownerhorsekindstats.totalcount : "";
  let totalpagesdata = ownerhorsekindstats ? ownerhorsekindstats.totalPages : "";
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(11);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // ACCORDION INDEXING
  const [outerCompIndex, setOuterCompIndex] = useState(null);
  const [innerCompIndex, setInnerCompIndex] = useState(null);

  // MODAL STATES PRESERVED
  const [ShowJockey, setShowJockey] = useState(false);
  const [modaldatasJockey, setmodaldatasJockey] = useState();
  const [showRace, setShowRace] = useState(false);
  const [modaldataRace, setmodaldataRace] = useState();
  const [ShowHorse, setShowHorse] = useState(false);
  const [modaldatasHorse, setmodaldatasHorse] = useState();
  const [shows, setShows] = useState(false);
  const [modaldatas, setmodaldatas] = useState();

  const handleCloses = () => setShows(false);
  const handleShows = async (data) => { setmodaldatas(data); await setShows(true); };
  const handleShowHorse = (data) => {
    const id = data?._id || data;
    if (id) navigate("/horse-detail?" + id);
  };
  const handleShowJockey = (data) => {
    const jId = data?._id || data;
    if (jId) navigate("/jockey-detail?" + jId);
  };
  const handleShowRace = (id) => {
    if (id) navigate("/race-detail?" + id);
  };

  useEffect(() => {
    dispatch(fetchownerhorsekindStats({ id, currentPage }));
  }, [currentPage, id, dispatch]);

  const handleTrainerRecord = (horseid, index) => {
    if (innerCompIndex === index) { setInnerCompIndex(null); return; }
    setInnerCompIndex(index);
    dispatch(fetchOwnerHorsesHistory({ horseid, id }));
  };

  const FirstLetter = (data) => data ? data.substring(0, 1) : "";

  function distanceLabel(distance, rank) {
    const d = parseFloat(distance);
    if (d.toFixed(2) > 25) return "Dist";
    else if (d.toFixed(2) == 0.05 && rank < 80) return "SHd";
    else if (d.toFixed(2) == 0.10 && rank < 80) return "Hd";
    else if (d.toFixed(2) == 0.25 && rank < 80) return "Nk";
    else if (d.toFixed(2) == 0.01 && rank < 80) return "Ns";
    else if (d.toFixed(2) == 0.00 && rank < 80) return rank === 1 ? 0 : "Dh";
    else return distance;
  }

  return (
    <div className="horse-kind-new-master-wrapper">
      
      {/* --- MAIN HEADER (9 Columns) --- */}
      <div className="horse-kind-new-main-thead">
        <div>{t("Horse Kind")}</div><div>{t("Runs")}</div><div>{t("Wins")}</div><div>{t("2nd")}</div>
        <div>{t("3rd")}</div><div>{t("4th")}</div><div>{t("5th")}</div><div>{t("Earning")}</div>
        <div>{t("Wins")}%</div><div></div>
      </div>

      <div className="horse-kind-new-list-box">
        {ownerhorsekindstats?.data && ownerhorsekindstats?.data?.map((item, i) => (
          <Accordion key={i} activeKey={outerCompIndex === i ? "0" : ""}>
            <Accordion.Item eventKey="0" className="horse-kind-new-outer-acc-item">
              
              <Accordion.Header className="horse-kind-new-outer-header" onClick={() => setOuterCompIndex(outerCompIndex === i ? null : i)}>
                <div className="horse-kind-new-header-grid">
                  <div className="new-bold-blue">{cookiedata === "en" ? item.NameEn : item.NameAr}</div>
                  <div>{item?.Runs}</div><div>{item?.wins}</div><div>{item?.second}</div>
                  <div>{item?.third}</div><div>{item?.fourth}</div><div>{item?.fifth}</div>
                  <div className="new-bold">AED {item?.earning || 0}</div>
                  <div>{Number(item?.winspercentage || 0).toFixed(2)}%</div>
                  <div style={{textAlign: 'right'}}><IoIosArrowDropdownCircle className="horse-kind-new-arrow" /></div>
                </div>
              </Accordion.Header>

              <Accordion.Body className="horse-kind-new-outer-body">
                {/* --- NESTED ITEMS (Level 2) --- */}
                {item?.KindHorseData === undefined ? <PleaseWait /> : (
                  item.KindHorseData.map((sub, j) => (
                    <Accordion key={j} activeKey={innerCompIndex === sub._id ? "0" : ""}>
                      <Accordion.Item eventKey="0" className="horse-kind-new-inner-acc-item">
                        <Accordion.Header className="horse-kind-new-inner-header" onClick={() => handleTrainerRecord(sub._id, sub._id)}>
                          <div className="horse-kind-new-header-grid">
                             <div className="new-bold-dark" onClick={(e) => {e.stopPropagation(); handleShowHorse(sub._id);}}>{cookiedata === "en" ? sub.NameEn : sub.NameAr}</div>
                             <div>{sub.Runs}</div><div>{sub.wins}</div><div>{sub.second}</div>
                             <div>{sub.third}</div><div>{sub.fourth}</div><div>{sub.fifth}</div>
                             <div>AED {sub.earning || 0}</div><div>{Number(sub.winspercentage || 0).toFixed(2)}%</div>
                             <div style={{textAlign: 'right'}}>
                                {innerCompIndex === sub._id ? <MdKeyboardArrowDown className="horse-kind-new-arrow-small" /> : <MdKeyboardArrowRight className="horse-kind-new-arrow-small" />}
                             </div>
                          </div>
                        </Accordion.Header>

                        {/* --- HISTORY TABLE (16 COLUMNS) (Level 3) --- */}
                        <Accordion.Body style={{padding: 0}}>
                          {innerCompIndex === sub._id && (
                            <div className="horse-kind-new-details-wrap">
                               <ScrollContainer className="horse-kind-new-inner-scroll">
                                  <div className="horse-kind-new-16col-table">
                                      <div className="horse-kind-new-thead-16">
                                          <div>{t("Date")}</div><div>{t("Crs")}</div><div>{t("Horse Name")}</div><div>{t("Dist")}</div><div>{t("RT")}</div><div>{t("Time")}</div><div>{t("Jockey")}</div><div>{t("Wgt")}</div><div>{t("FP")}</div><div>{t("Len")}</div><div>{t("RN")}</div><div>{t("BtBy")}</div><div>{t("Kgs")}</div><div>{t("Draw")}</div><div>{t("OR")}</div><div>{t("Link")}</div>
                                      </div>
                                      <div className="horse-kind-new-tbody-16">
                                          {OwnerHorsesHistory?.length === 0 ? <NoHistory /> : (
                                            OwnerHorsesHistory?.map((historyItem, hIdx) => {
                                                const ground = historyItem.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.TrackLengthData?.GroundTypeModelData?.NameEn;
                                                const rowBg = ground === "Dirt" ? "#e3d4ca" : ground === "Turf" ? "#cbedba" : "#949494";
                                                return (
                                                  <div key={hIdx} className="horse-kind-new-row-16" style={{ backgroundColor: rowBg, color: '#343433 ' }}>
                                                      <div onClick={() => handleShowRace(historyItem.RaceID)} className="new-clickable-white"><Moment format="DD/MM/YYYY">{historyItem.RaceResultData?.Day}</Moment></div>
                                                      <div>{cookiedata === "en" ? historyItem.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.RaceCourseData?.AbbrevEn : historyItem.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.RaceCourseData?.AbbrevAr}({FirstLetter(cookiedata === "en" ? ground : historyItem.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.TrackLengthData?.GroundTypeModelData?.NameAr)})</div>
                                                      <div className="clickable-text" onClick={(e) => { e.stopPropagation(); handleShowHorse(sub._id); }}>{cookiedata === "en" ? toTitleCase(sub.NameEn) : sub.NameAr}</div>
                                                      <div>{historyItem.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.TrackLengthData?.TrackLength}</div>
                                                      <div className="horse-kind-new-truncate">{cookiedata === "en" ? toTitleCase(truncateRaceType(historyItem.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.RaceTypeModelData?.NameEn)) : historyItem.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.RaceTypeModelData?.NameAr}</div>
                                                      <div>{historyItem.RaceTime}</div>
                                                      <div onClick={() => handleShowJockey(historyItem.JockeyOnRaceDataResult)} className="new-clickable-white">{cookiedata === "en" ? toTitleCase(historyItem.JockeyOnRaceDataResult?.ShortNameEn || historyItem.JockeyOnRaceDataResult?.NameEn) : historyItem.JockeyOnRaceDataResult?.ShortNameAr || historyItem.JockeyOnRaceDataResult?.NameAr}</div>
                                                      <div>{historyItem.RaceResultData?.RacehorsesData?.[0]?.JockeyRaceWeight}</div>
                                                      <div>{cookiedata === "en" ? toTitleCase(historyItem.FinalPositionDataHorse?.NameEn) : historyItem.FinalPositionDataHorse?.NameAr}</div>
                                                      <div>{distanceLabel(historyItem.Distance, historyItem.FinalPositionDataHorse?.Rank)}</div>
                                                      <div>{historyItem.Runners}</div>
                                                      <div className="horse-kind-new-truncate new-clickable-white" onClick={() => handleShowHorse(historyItem.BeatenByData?._id || historyItem.BeatenByData)}>{historyItem.BeatenByData ? (cookiedata === "en" ? toTitleCase(historyItem.BeatenByData.NameEn) : historyItem.BeatenByData.NameAr) : (cookiedata === "en" ? toTitleCase(historyItem.HorseIDData?.HorseBeatenByEnglishName) : historyItem.HorseIDData?.HorseBeatenByArabicName || "-")}</div>
                                                      <div>{historyItem.BeatenByData ? historyItem.BeatenByData?.WinningHorseJockeyWeight : "0"}</div>
                                                      <div>{historyItem.RaceResultData?.RacehorsesData?.[0]?.HorseNo || "-"}</div>
                                                      <div>{historyItem.Rating || 0}</div>
                                                      <div onClick={() => handleShows(historyItem.VideoLink)} className="new-play-btn-white"><IoMdPlay /></div>
                                                  </div>
                                                );
                                            })
                                          )}
                                      </div>
                                  </div>
                               </ScrollContainer>
                            </div>
                          )}
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  ))
                )}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        ))}
      </div>

      <div className="horse-kind-new-pagination">
          <Pagination postsPerPage={postsPerPage} totalPosts={totalcountdata} paginate={paginate} currentPage={currentPage} TotalPages={totalpagesdata} />
      </div>

      {/* --- ALL MODALS PRESERVED --- */}
      <Modal show={shows} onHide={handleCloses} size="lg" centered><Modal.Body><VideoFrame data={modaldatas} /></Modal.Body></Modal>
    </div>
  );
};

export default Stats;